<div class="skeleton-title pb-48 pr-body pl-body"></div>
<div class="grid-product-list grid-product-list-2">
    @for (item of itemsArray; track $index) {
        <div class="grid-product grid-product-view2">
            <div class="full-size p-view">
                <div class="content-product-card">
                    <div class="product-card">
                        <media-skeleton [ratio]="ratio()"></media-skeleton>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
